import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

interface IconSignalBarsProps extends SvgProps {
  numberOfBars?: number;
}

export const IconSignalBarsGroup: React.FC<IconSignalBarsProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  const numberOfBars = props.numberOfBars ?? 0;

  return (
    <g fill="none" {...(props.group ?? {})}>
      <line x1="1.5" y1="7" x2="1.5" y2="10" stroke="#D6D8D9" strokeWidth="3" />
      {numberOfBars >= 1 && (
        <line
          x1="1.5"
          y1="7"
          x2="1.5"
          y2="10"
          stroke={fillColor}
          strokeWidth="3"
        />
      )}
      <line x1="6.5" y1="5" x2="6.5" y2="10" stroke="#D6D8D9" strokeWidth="3" />
      {numberOfBars >= 2 && (
        <line
          x1="6.5"
          y1="5"
          x2="6.5"
          y2="10"
          stroke={fillColor}
          strokeWidth="3"
        />
      )}
      <line
        x1="11.5"
        y1="2"
        x2="11.5"
        y2="10"
        stroke="#D6D8D9"
        strokeWidth="3"
      />
      {numberOfBars >= 3 && (
        <line
          x1="11.5"
          y1="2"
          x2="11.5"
          y2="10"
          stroke={fillColor}
          strokeWidth="3"
        />
      )}
      <line
        x1="16.5"
        y1="-5.04362e-08"
        x2="16.5"
        y2="10"
        stroke="#D6D8D9"
        strokeWidth="3"
      />
      {numberOfBars >= 4 && (
        <line
          x1="16.5"
          y1="-5.04362e-08"
          x2="16.5"
          y2="10"
          stroke={fillColor}
          strokeWidth="3"
        />
      )}
    </g>
  );
};

export const IconSignalBarsSvg: React.FC<IconSignalBarsProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="10"
      viewBox="0 0 18 10"
      {...(props.svg ?? {})}
    >
      <IconSignalBarsGroup {...props} />
    </svg>
  );
};
